module.exports = __webpack_public_path__ + "img/epBg.e64043c8.png";